import React from 'react';

function Help() {
  return (
    <div className="container mx-auto p-0 md:pl-6 md:pr-0">
      <main className="max-w-3xl mx-auto p-6">
        <h1 className="text-4xl font-bold text-center mb-8 text-white">Hogyan segíthetsz?</h1>
        <p className="text-lg text-justify text-gray-200 mt-2">
          Nem mindenki lesz beteg, de mindenki lehet segítő. Az alábbiakban olyan lehetőségeket gyűjtöttem össze, amelyekkel te is életet menthetsz, akárcsak néhány percet szánva rá.
        </p>

        {/* Véradás */}
        <div className="bg-[#1F2233] p-4 rounded-lg mt-6 shadow-md">
          <p className="text-lg text-justify text-gray-200 whitespace-pre-line">
            🩸 <strong>Adj vért</strong>
            {'\n'}A vérellátás folyamatosan kihívás elé állítja az egészségügyet, pedig egyetlen véradás három ember életét is megmentheti. Rengeteg beteg, sérült ember, gyakran szorul vérkészítményekre – vörösvértestre, vérlemezkére.
            {'\n'}📍 A legközelebbi véradás helyszínét és idejét itt találod:
            {'\n'}👉 <a href="https://www.veradas.hu" target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">https://www.veradas.hu</a>
          </p>
        </div>

        {/* Őssejt-donor */}
        <div className="bg-[#1F2233] p-4 rounded-lg mt-6 shadow-md">
          <p className="text-lg text-justify text-gray-200 whitespace-pre-line">
            🌱 <strong>Jelentkezz őssejt-donornak</strong>
            {'\n'}Véradáskor lehetőség van őssejtdonornak való jelentkezésre is. Ez különösen fontos, mert az őssejt-transzplantáció sok leukémiás beteg számára az egyetlen esély a gyógyulásra – ahogyan az számomra is volt.
            {'\n'}Regisztráció után csak egy vérmintát kell adnod, és ha egyszer valakihez passzolsz, megmentheted az életét.
            {'\n\n'}További információ:
            {'\n'}👉 <a href="https://www.ovsz.hu/hu/csv/legyel-te-ossejtdonor" target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">https://www.ovsz.hu/hu/csv/legyel-te-ossejtdonor</a>
          </p>
        </div>

        {/* SMS támogatás */}
        <div className="bg-[#1F2233] p-4 rounded-lg mt-6 shadow-md">
          <p className="text-lg text-justify text-gray-200 whitespace-pre-line">
            📱 <strong>Támogasd SMS-ben</strong>
            {'\n'}Szent László Őssejt Alapítvány-t mér SMS-ben is lehet támogatni, ahol nem kell személyes adatokat megadni és 500 Ft-al támogathatod az orvosaik munkáját, betegeik gyógyulását!
            {'\n'}A támogatás menete:
            {'\n'}1. Írd be a 13600-as számot a címzettekhez.
            {'\n'}2. A SMS szövege ez legyen: 29
            {'\n'}3. Küldd el az SMS-t.
            {'\n'}4. Várd meg a visszaigazoló SMS-t a sikerességről.
            {'\n\n'}További információ:
            {'\n'}👉 <a href="https://adjukossze.hu/adomanygyujtes/csatlakozz-az-ugyhoz-ossejt-transzplantacio-kozerthetoen-3320" target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">https://adjukossze.hu/adomanygyujtes</a>
          </p>
        </div>

        {/* Adó 1% */}
        <div className="bg-[#1F2233] p-4 rounded-lg mt-6 shadow-md">
          <p className="text-lg text-justify text-gray-200 whitespace-pre-line">
            💸 <strong>Ajánld fel adód 1%-át</strong>
            {'\n'}Ez az egyik legegyszerűbb módja a segítségnek, neked nem kerül semmibe, de másnak az életet jelentheti. Ha szeretnél tenni valamit, kérlek, támogasd a Szent László Őssejt Alapítványt, akik nélkül én sem tudtam volna elindulni a gyógyulás útján.
            {'\n\n'}Szent László Őssejt Alapítvány
            {'\n'}Adószám: 18088823-1-43
            {'\n\n'}További információ:
            {'\n'}👉 <a href="https://www.ossejtalapitvany.info/" target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">https://www.ossejtalapitvany.info/</a>
          </p>
        </div>

        {/* Záró gondolat */}
        <p className="text-lg text-justify text-gray-200 mt-6">
          Egy kis gesztus, egy esély az életre!
          {'\n'}Nem mindig tudjuk, kinek segítünk, de biztosan valakinek a világot jelentjük vele. Köszönöm, ha bármelyik formában segítő szándékkal cselekszel.
          {'\n'}Ez nem csak rólam szól. Ez mindannyiunkról szól.
        </p>
      </main>
    </div>
  );
}

export default Help;